import { render, staticRenderFns } from "./VireedPlayerPage.vue?vue&type=template&id=6fb1a491&scoped=true&"
import script from "./VireedPlayerPage.vue?vue&type=script&lang=js&"
export * from "./VireedPlayerPage.vue?vue&type=script&lang=js&"
import style0 from "./VireedPlayerPage.vue?vue&type=style&index=0&id=6fb1a491&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb1a491",
  null
  
)

export default component.exports